module.exports = __webpack_public_path__ + "img/examen.05ef93b1.png";